export default {
    async loadFacebookSDK() {
        var js,
            fjs = document.getElementsByTagName("script")[0];
        if (document.getElementById("facebook-jssdk")) {
            return;
        }
        js = document.createElement("script");
        js.id = "facebook-jssdk";
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
    },
    async initFacebook() {
        window.fbAsyncInit = function() {
            window.FB.init({
                appId: "247521926526038", //You will need to change this
                cookie: true, // This is important, it's not enabled by default
                version: "v7.0",
            });
        };
    },

    async login() {
        return new Promise((resolve) => {
            window.FB.login(function (response) {
                if (response.authResponse) {
                    resolve(response);
                } else {
                    resolve(false);
                }
            }, {scope: 'public_profile, email'});
        });
    },

    async me() {
        let login = await this.login();
        if (login === false) {
            return false;
        }

        return new Promise((resolve) => {
            window.FB.api('/me?fields=name,email', function (response) {
                resolve(response);
            });
        });
    }
}